import { CourseInboxReplyAPI } from '@business/api/course_inbox_reply';
import { CourseInboxReplyResponse, CourseInboxUserType, CourseInboxId } from '@business/entities/course_inbox';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { SendMessageFormData } from '@modules/CourseInboxPage/CourseInboxReplyPage/SendMessage';

export class CourseInboxReplyBloc extends BaseBloc {
  private readonly replyRepo = new Repository<CourseInboxReplyResponse>({
    getItemId: item => item.id,
  });

  readonly replies$ = this.replyRepo.items$;
  readonly selectCourseInboxReply = this.replyRepo.selectItem;

  onReset() {
    this.replyRepo.reset();
  }

  fetchCourseInboxReplies = (inboxId: CourseInboxId) => {
    return CourseInboxReplyAPI.fetchCourseInboxReplies(inboxId).pipe(this.replyRepo.ops.reset());
  };

  createCourseInboxReply = (data: SendMessageFormData) => {
    return CourseInboxReplyAPI.createCourseInboxReply(data).pipe(this.replyRepo.ops.upsertOne(item => ({ item })));
  };
}
